export enum AccountSubdomainEnum {
  MSC = 'msc',
  POSTAL = 'postal',
  LPC = 'lpc',
  DHTX = 'dhtx',
}
